<template>
    <div class="signup-form">
      <toast-message
        :message="errmsg"
        type="error"
        :isToastEnable="toast"
        @close="(val) => toast = val"
      />
      <form>
        <p class="first-label">Full Name</p>
        <input
          class="input-field"
          type="text"
          placeholder="Enter Name"
          v-model="formData.name"
          name="fullName"
          v-validate="'required'"
        />
        <span class="errorMessage" v-show="errors.has('fullName')">{{ errors.first('fullName') }}</span>
        <p class="label">Organisation Name</p>
        <input
          class="input-field"
          type="text"
          name
          placeholder="Organisation Name"
          v-model="formData.orgname"
        />
        <p class="label">Email id</p>
        <input
          class="input-field"
          type="email"
          placeholder="Email id"
          v-model="formData.email"
          name="email"
          v-validate="'required'"
        />
        <span class="errorMessage" v-show="errors.has('email')">{{ errors.first('email') }}</span>
        <p class="label">User Name(User Code)</p>
        <input
          class="input-field"
          type="text"
          placeholder="Enter User Name"
          v-model="formData.ecode"
          name="userName"
          v-validate="'required'"
        />
        <span class="errorMessage" v-show="errors.has('userName')">{{ errors.first('userName') }}</span>
        <p class="label">Comapany Code</p>
        <input
          class="input-field"
          type="text"
          placeholder="Enter Company Code"
          v-model="formData.companyCode"
          name="companyCode"
          v-validate="'required'"
        />
        <span class="errorMessage" v-show="errors.has('companyCode')">{{ errors.first('companyCode') }}</span>
        <p class="label phone-number">
          Phone Number
          <span>(optional)</span>
        </p>
        <input
          class="input-field"
          type="number"
          placeholder="Phone number"
          v-model="formData.phoneNumber"
        />
        <!-- <button type="button" class="signup-btn" @click="signupUser()">Save
        </button> -->
        <!-- <div class="signin-text">
          <div>Already have an account ?&nbsp;</div>
          <router-link to="/signin">Sign In</router-link>
        </div> -->
      </form>
      <pop-up-message
        v-if="showSuccessMsg"
        :message="`You have successfully signed up. Please check your mail to set your password.`"
        btnText="OK"
        @back="gotoSignIn()"
      ></pop-up-message>
      <footer>
        <popup-bottom-container class="position-fixed marginleft">
            <btn-grp slot="end">
              <btn text="Cancel" type="secondary" @click="backToWelcomeScreen" />
              <btn text="Save" type="primary" @click="signupUser"></btn>
            </btn-grp>
        </popup-bottom-container>
      </footer>
    </div>
</template>
<script>
import { mapActions } from "vuex";
import LoginShell from "./loginShell.vue";

export default {
  components: {
    LoginShell
  },
  data() {
    return {
      showSuccessMsg: false,
      toast: false,
      errmsg: "",
      formData: {
        name: "",
        email: "",
        phoneNumber: "",
        orgname: "",
        companyCode: "",
        ecode:""
      },
    };
  },
  methods: {
    ...mapActions({
      signupuser: "auth/signup"
    }),
    async signupUser() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.performAction();
        }
      });
    },

    backToWelcomeScreen() {
      this.$emit('back');
    },

    async performAction() {
      try {
        let res = await this.signupuser({
          name: this.formData.name,
          email: this.formData.email,
          phoneNumber: this.formData.phoneNumber,
          login: this.formData.email,
          userRole: 'ADMIN',
          createdBy: localStorage.getItem('loginId'),
          companyCode: this.formData.companyCode,
          ecode: this.formData.ecode
        });

        if (res.status) {
          this.showSuccessMsg = true;
        } else {
          this.errmsg = res ? res : "Something went wrong from server side.";
          this.toast = true;
        }

        if (res.message != null) {
          throw Error(res.message);
        }
      } catch (err) {
        this.errmsg = err;
        this.toast = true;
      }
    },

    gotoSignIn() {
      this.$router.push({ path: "/signin" });
    }
  }
};
</script>

<style lang="scss" scoped>
.signup-form {
  width: 350px;
  background-color: #fff;
  border-radius: 4px;
  // box-shadow: 2px 2px 8px 0 rgba(0, 0, 0, 0.2);
  // padding: 16px 40px 25px 40px;
}
.label {
  height: 15px;
  margin-bottom: 9px;
  margin-top: 25px;
  font-family: Montserrat;
  font-size: 14px;
  color: #0e0e0e;
}

.first-label {
  height: 15px;
  margin-bottom: 9px;
  font-family: Montserrat;
  font-size: 14px;
  color: #0e0e0e;
}

.signup-form .input-field {
  width: 100%;
  height: 43px;
  border-radius: 4px;
  padding: 15px 9px;
  outline: 0;
  border: 1px solid #d8d8d8;
  background-color: #ffffff;
  &:focus {
    outline: none;
    border: 2px solid #34c0be;
  }
}
.signup-btn {
  margin-top: 20px;
  width: 100%;
  cursor: pointer;
  height: 45px;
  border-radius: 4px;
  color: #fff;
  font-size: 15px;
  border: none;
  box-shadow: 2px 2px 8px 0 rgba(0, 0, 0, 0.1);
  background-color: #5d409f;
}
.signin-text {
  display: flex;
  margin-top: 15px;
  justify-content: center;
  align-items: center;
}
.signin-text div {
  height: 15px;
  font-family: Montserrat;
  font-size: 14px;
  color: #868686;
}
.signin-text a {
  text-decoration: none;
}
.phone-number {
  position: relative;
}
.phone-number span {
  position: absolute;
  right: 0;
  color: #0e0e0e;
  opacity: 0.59;
}
@media only screen and (max-width: 600px) {
  .signin-form {
    padding: 16px 20px 25px 20px;
  }
}
.errorMessage {
  color: #e01717;
  padding-top: 5px;
}
</style>
